import { useStore } from '@/store';
import { selectInterpretation } from '@/store/selectors';

/** Maps fPercent + mode to a band sentence (F-036, P1.6.3). */
export function InterpretationBand() {
  const interpretation = useStore(selectInterpretation);
  if (!interpretation) return null;
  return <div className="interpretation-band">{interpretation}</div>;
}
